import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import BillingBanner from './BillingBanner';
import IntegrationBanner from './IntegrationBanner';
import VerifyEmailBanner from './VerifyEmailBanner';

const BaseAppBanner = () => {
  const isVerifiedEmailBannerActive = VerifyEmailBanner.useIsActive();
  const isBillingBannerActive = BillingBanner.useIsActive();
  const isIntegrationBannerActive = IntegrationBanner.useIsActive();

  if (isVerifiedEmailBannerActive) {
    return <VerifyEmailBanner />;
  }

  if (isBillingBannerActive) {
    return <BillingBanner />;
  }

  if (isIntegrationBannerActive) {
    return <IntegrationBanner />;
  }

  return null;
};

const AppBanner = () => {
  const organization = useAppSelector((state) => state.session.organization);

  return organization?.id ? <BaseAppBanner /> : null;
};

export default AppBanner;
